import {Swiper, Pagination} from 'asteq.swiper';
import {BaseDetailSlider} from 'asteq.sliders.basedetailslider';

export class CardSlider extends BaseDetailSlider {
	constructor(sliderBlock, params) {
		super(sliderBlock, params);
	}

	initSwipers() {
		if (this.mainSwiperBlock) {
			this.mainSwiper = new Swiper(this.mainSwiperBlock, {
				modules: [Pagination],
				pagination: {
					el: ".swiper-pagination",
					bulletClass:
						"dark:after:bg-white/50 after:bg-main-black/50 only:hidden",
					bulletActiveClass:
						"dark:after:!bg-main after:!bg-main-black",
				},
				breakpoints: {
					0: {pagination: {clickable: !0}},
					1280: {pagination: {clickable: !1}},
				},
				on: {
					paginationRender: (n) => {
						n.pagination.bullets.forEach((r, s) => {
							r.addEventListener("mouseover", (d) => {
								n.slideTo(s);
							});
						}),
							n.el.addEventListener("mouseout", () => {
								n.slideTo(0);
							});
					},
				},
			});

			if (this.mainSwiper && this.mainSwiper.initialized) {
				const firstSlide = this.mainSwiper.wrapperEl.children[0];
				if (firstSlide) {
					this.mainSwiperSlideTemplate = firstSlide.cloneNode(true);
				}
			}
		}
	}
}